import React from 'react';
import Featured from './featured/Featured';
import Layouts from '../../layouts/Layouts';
import TopicBanner from '../../Components/topicBanner/TopicBanner';
import bnrInnerImg from '../../assets/images/png/topicbanner-img3.png';
import bnrImg from '../../assets/images/png/topicbnr3.png';
import HealthyEating from './healthyEating/HealthyEating';
import AddRow from '../../Components/addRow/AddRow';
import CookingMealPrep from './cookingMealPrep/CookingMealPrep';
import MoreInHealth from './moreInHealth/MoreInHealth';

function DiscoverWellnessInnerPage() {
  return (
    <Layouts>
      <section className="discoverWellnessInnerPage">
        <TopicBanner
          bgImg={bnrImg}
          img={bnrInnerImg}
          title="Health"
          desc="Become your best self. Discover new ways to live an inspiring life through natural beauty, nutrition and diet, an active lifestyle, and better relationships."
        />
        <Featured />
        <HealthyEating />
        <CookingMealPrep />
        <AddRow />
        <MoreInHealth />
      </section>
    </Layouts>
  );
}

export default DiscoverWellnessInnerPage;
